"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./loading-spinner.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function LoadingSpinner(props) {
  var color = props.color,
      spacing = props.spacing,
      size = props.size,
      centered = props.centered;
  var wrapperStyle = {
    height: size,
    padding: spacing * 4
  };
  var divStyle = {
    height: size,
    width: size,
    border: "".concat(Math.round(size / 8), "px solid #FFF"),
    borderColor: "".concat(color, " transparent transparent transparent")
  };

  var loadingSpinner = _react.default.createElement("div", {
    style: wrapperStyle,
    "data-testid": "loading-spinner"
  }, _react.default.createElement("div", {
    className: "lds-ring inline-block relative",
    style: {
      height: size,
      width: size
    }
  }, _react.default.createElement("div", {
    className: "block absolute rounded-full",
    style: divStyle
  }), _react.default.createElement("div", {
    className: "block absolute rounded-full",
    style: divStyle
  }), _react.default.createElement("div", {
    className: "block absolute rounded-full",
    style: divStyle
  }), _react.default.createElement("div", {
    className: "block absolute rounded-full",
    style: divStyle
  })));

  return centered ? _react.default.createElement("div", {
    className: "flex justify-center items-center"
  }, loadingSpinner) : loadingSpinner;
}

LoadingSpinner.propTypes = {
  color: _propTypes.default.string,
  spacing: _propTypes.default.number,
  size: _propTypes.default.number,
  centered: _propTypes.default.bool
};
LoadingSpinner.defaultProps = {
  color: '#33CE9B',
  spacing: 0,
  size: 48,
  centered: false
};

var _default = _react.default.memo(LoadingSpinner);

exports.default = _default;